module.exports = __webpack_public_path__ + "img/avatarRight.16693c25.webp";